import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFieldGps = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 28 37",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14 0c7.743 0 14 6.564 14 14.668 0 6.737-3.964 13.854-11.75 21.41a3.207 3.207 0 01-4.5 0C3.964 28.522 0 21.405 0 14.668 0 6.564 6.257 0 14 0zm0 3.419c-5.916 0-10.706 5.025-10.706 11.249 0 5.618 3.522 11.941 10.706 18.913 7.184-6.972 10.706-13.295 10.706-18.913 0-6.224-4.79-11.249-10.706-11.249zm0 17.095c-3.183 0-5.765-2.68-5.765-5.983 0-3.304 2.582-5.984 5.765-5.984s5.765 2.68 5.765 5.984c0 3.303-2.582 5.983-5.765 5.983zm0-3.42c1.363 0 2.47-1.148 2.47-2.563 0-1.415-1.107-2.565-2.47-2.565-1.363 0-2.47 1.15-2.47 2.565s1.107 2.564 2.47 2.564z",
		fillRule: "nonzero"
	})
});
export default SvgFieldGps;
